module.exports = "/_next/static/images/truck-418125d36b36c3ea3b8ca6eadc6a976b.jpg";